import React, { useState, useEffect, useCallback } from 'react';
import Header from './Header';
import HomePage from './HomePage';
import Footer from './Footer';

import ComunidadPage from './ComunidadPage';
import CostalHomePage from './CostalHomePage';
import CostalComunidadPage from './CostalComunidadPage';
import MemberResetPasswordPage from './MemberResetPasswordPage';
import AdminLoginPage from './AdminLoginPage';
import MemberPerfilPage from './MemberPerfilPage';
import ShoppingCart from './ShoppingCart';
import GeoShippingNotice from './GeoShippingNotice';
import Checkout from './Checkout';
import BienestarYogaPage from './BienestarYogaPage';
import BienestarEntrenamientoPage from './BienestarEntrenamientoPage';
import BienestarConectaPage from './BienestarConectaPage';
import BienestarReservarPage from './BienestarReservarPage';
import BienestarReprogramarPage from './BienestarReprogramarPage';
import ConoceColombiaPage from './ConoceColombiaPage';
import VoluntariadoPage from './VoluntariadoPage';
import ContactoPage from './ContactoPage';
import TiendaPage from './TiendaPage';
import GrowthPartnerPage from './GrowthPartnerPage';
// FrankensteinPage removido de lo público (proyecto pausado, no cancelado)
import NewsPage from './NewsPage';
import ProductosPage from './ProductosPage';
import ProductDetailPage from './ProductDetailPage';
import { 
  Preloader 
} from './LazyLoader';
import MembersManagement from './MembersManagement';
import UserManagement from './UserManagement';
import SystemSettings from './SystemSettings';
import ActivityLogs from './ActivityLogs';
import ProductManagement from './ProductManagement';
import TestimoniosAdmin from './TestimoniosAdmin';
import InvoicesManagement from './InvoicesManagement';
import OrdersManagement from './OrdersManagement';
import BienestarBookingsManagement from './BienestarBookingsManagement';
import PackagingManagement from './PackagingManagement';
import QuotationsManagement from './QuotationsManagement';
import QuotationPublicUploadPage from './QuotationPublicUploadPage';
import UserLogin from './UserLogin';
import UserRegistration from './UserRegistration';
import SimpleDashboard from './SimpleDashboard';
import AdminLayout from './AdminLayout';
import GrowthPartnerProjects from './GrowthPartnerProjects';
import CanalTiendaPanel from './CanalTiendaPanel';
import MarketingHub from './MarketingHub';
import ErrorBoundary from './ErrorBoundary';
import SEOHead from './SEOHead';
import { getSeoForPage } from '../constants/seoRoutes';
import { trackPageView } from '../utils/analytics';
import { adminService } from '../services/api';
import { ADMIN_OPS_REFRESH } from '../constants/adminEvents';
import ResetPasswordPage from './ResetPasswordPage';
import TermsAndConditionsPage from './TermsAndConditionsPage';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import RefundPolicyPage from './RefundPolicyPage';
import FaqAyudaPage from './FaqAyudaPage';
import BrandLandingPage from './BrandLandingPage';
import ProductStudioLanding from './ProductStudioLanding';
import ProyectosDigitalesPage from './ProyectosDigitalesPage';
import LinajeMockLanding from './LinajeMockLanding';
import './AppRouter.css';

const PROYECTO_BRAND_PAGES = {
  '/proyectos/saludable': 'saludable',
  '/proyectos/ropa': 'ropa',
  '/proyectos/bakata': 'bakata',
  '/proyectos/linaje': 'linaje',
  '/proyectos/strutech': 'strutech',
  '/proyectos/meridian': 'meridian',
  '/proyectos/turismo': 'turismo',
};

/** Lee sesión staff guardada (localStorage). */
function readAdminSessionFromStorage() {
  try {
    const token = localStorage.getItem('javiland_token');
    const userRaw = localStorage.getItem('javiland_user');
    if (token && userRaw) {
      const user = JSON.parse(userRaw);
      return { ok: true, user };
    }
    if (token) localStorage.removeItem('javiland_token');
    if (userRaw) localStorage.removeItem('javiland_user');
  } catch (e) {
    localStorage.removeItem('javiland_token');
    localStorage.removeItem('javiland_user');
  }
  return { ok: false, user: null };
}

/**
 * Pathname del navegador → clave `currentPage` (misma lógica en carga inicial y en popstate).
 */
function resolvePageFromPath(pathname, search, hash) {
  const path = (pathname || '/').replace(/\/$/, '') || '/';
  const h = (hash || '').replace(/^#/, '');

  /** Rutas pausadas o retiradas de la marca pública (jul 2026) */
  const PAUSED_TO_HOME = [
    '/growth-partner',
    '/bienestar',
    '/bienestar/yoga',
    '/bienestar/entrenamiento',
    '/bienestar/conecta',
    '/bienestar/reservar',
    '/bienestar/reprogramar',
    '/conecta-tu-camino',
    '/noticias',
    '/voluntariado',
    '/rentas',
    '/conoce-colombia',
  ];
  if (PAUSED_TO_HOME.includes(path) || path.startsWith('/noticias/')) {
    return { page: 'home', replacePath: '/' };
  }
  if (path === '/quienes-somos') {
    return { page: 'costal-home', replacePath: '/costal' };
  }
  if (path === '/proyectos') {
    return { page: 'proyectos' };
  }
  if (path === '/proyectos/saludable') {
    return { page: 'costal-home', replacePath: '/costal' };
  }
  if (PROYECTO_BRAND_PAGES[path]) {
    return { page: 'brand-landing', brandId: PROYECTO_BRAND_PAGES[path] };
  }
  if (path === '/servicios/product-studio' || path === '/servicios') {
    return { page: 'product-studio' };
  }
  if (path === '/linaje') {
    return { page: 'linaje-mock' };
  }

  const BIENESTAR_HASH_REDIRECTS = {
    'sesion-yoga': '/bienestar/yoga',
    'sesiones-a-tu-medida': '/bienestar/yoga',
    'programas-yoga': '/bienestar/yoga',
    'sesion-entrenamiento': '/bienestar/entrenamiento',
    'programa-conecta': '/bienestar/conecta',
    'acompanamiento-aliados': '/bienestar/conecta',
    'comunidad-deportiva': '/bienestar/entrenamiento',
  };

  if (path === '/bienestar' && h && BIENESTAR_HASH_REDIRECTS[h]) {
    const dest = BIENESTAR_HASH_REDIRECTS[h];
    const pageByDest = {
      '/bienestar/yoga': 'bienestar-yoga',
      '/bienestar/entrenamiento': 'bienestar-entrenamiento',
      '/bienestar/conecta': 'bienestar-conecta',
    };
    return { page: pageByDest[dest] || 'bienestar', replacePath: dest };
  }

  if (path.startsWith('/cotizacion-adjuntos/') && path.replace('/cotizacion-adjuntos/', '').length >= 16) {
    return { page: 'quotation-upload' };
  }

  if (path === '/costal') {
    return { page: 'costal-home' };
  }
  if (path === '/unete') {
    return { page: 'comunidad-auth', replacePath: '/comunidad/ingresar' };
  }
  if (path === '/news') {
    return { page: 'noticias', replacePath: '/noticias' };
  }
  if (path === '/comunidad/restablecer') {
    return { page: 'comunidad-restablecer' };
  }
  if (
    path === '/comunidad/ingresar' ||
    path === '/comunidad/registro' ||
    path === '/comunidad/recuperar'
  ) {
    return { page: 'comunidad-auth' };
  }
  if (path === '/comunidad' || path.startsWith('/comunidad')) {
    return { page: 'costal-comunidad' };
  }
  if (path === '/reset-password' && String(search || '').includes('token=')) {
    return { page: 'reset-password' };
  }
  if (path === '/admin-login') {
    return { page: 'admin-login' };
  }
  if (path === '/perfil') {
    return { page: 'perfil' };
  }
  if (path === '/politicas/terminos' || path === '/terms-and-conditions') {
    return { page: 'terms-and-conditions' };
  }
  if (path === '/politicas/privacidad' || path === '/privacy-policy') {
    return { page: 'privacy-policy' };
  }
  if (path === '/refund-policy') {
    return { page: 'refund-policy' };
  }
  if (path === '/ecommerce' || path === '/tienda') {
    return { page: 'tienda' };
  }
  if (path === '/bienestar/yoga') {
    return { page: 'bienestar-yoga' };
  }
  if (path === '/bienestar/entrenamiento') {
    return { page: 'bienestar-entrenamiento' };
  }
  if (path === '/bienestar/conecta') {
    return { page: 'bienestar-conecta' };
  }
  if (path === '/bienestar') {
    return { page: 'tienda', replacePath: '/tienda?category=productos-naturales' };
  }
  if (path === '/bienestar/reservar') {
    return { page: 'bienestar-reservar' };
  }
  if (path === '/bienestar/reprogramar') {
    return { page: 'bienestar-reprogramar' };
  }
  if (path === '/rentas') {
    return { page: 'product-studio', replacePath: '/servicios/product-studio' };
  }
  if (path === '/voluntariado') {
    return { page: 'product-studio', replacePath: '/servicios/product-studio' };
  }
  if (path === '/conecta-tu-camino') {
    return { page: 'bienestar-conecta', replacePath: '/bienestar/conecta' };
  }
  if (path === '/contacto') {
    return { page: 'contacto' };
  }
  if (path === '/preguntas-frecuentes' || path === '/ayuda' || path === '/faq') {
    return { page: 'faq-ayuda' };
  }
  if (path === '/noticias' || path.startsWith('/noticias/')) {
    return { page: 'noticias' };
  }
  if (path === '/servicios') {
    return { page: 'product-studio', replacePath: '/servicios/product-studio' };
  }
  if (path === '/checkout' || path.startsWith('/checkout/')) {
    return { page: 'checkout' };
  }
  if (path === '/quienes-somos') {
    return { page: 'noticias', replacePath: '/noticias/javiland' };
  }
  if (path === '/productos') {
    return { page: 'productos' };
  }
  if (path.match(/^\/producto\/\d+$/)) {
    return { page: 'producto-detail' };
  }
  if (path === '/growth-partner') {
    return { page: 'growth-partner' };
  }
  if (path === '/admin') {
    return { page: 'admin' };
  }
  if (path === '/login') {
    return { page: 'user-login' };
  }
  if (path === '/register') {
    return { page: 'user-register' };
  }
  return { page: 'home' };
}

/** Sin sesión: /admin → login staff. Con sesión: /admin-login → panel (evita “segundo paso”). */
function applyAdminRouteGuards(page) {
  const { ok } = readAdminSessionFromStorage();
  if (page === 'admin' && !ok) {
    window.history.replaceState({}, '', '/admin-login');
    return 'admin-login';
  }
  if (page === 'admin-login' && ok) {
    window.history.replaceState({}, '', '/admin');
    return 'admin';
  }
  return page;
}

function computeInitialRoutingState() {
  if (typeof window === 'undefined') {
    return {
      currentPage: 'home',
      isAuthenticated: false,
      currentUser: null
    };
  }
  const sess = readAdminSessionFromStorage();
  const raw = resolvePageFromPath(window.location.pathname, window.location.search, window.location.hash);
  if (raw.replacePath) {
    window.history.replaceState({}, '', raw.replacePath);
  }
  let page = applyAdminRouteGuards(raw.page);

  return {
    currentPage: page,
    isAuthenticated: sess.ok,
    currentUser: sess.user
  };
}

const initialRouting = computeInitialRoutingState();

const SECTION_PROCESS_KEYS = {
  packaging: 'chk001',
  invoices: 'sop_facturacion'
};

const AppRouter = () => {
  const [currentPage, setCurrentPage] = useState(initialRouting.currentPage);
  const [brandLandingId, setBrandLandingId] = useState(() => {
    if (typeof window === 'undefined') return 'saludable';
    const raw = resolvePageFromPath(window.location.pathname, window.location.search, window.location.hash);
    return raw.brandId || 'saludable';
  });
  const [adminSection, setAdminSection] = useState('dashboard');
  const [adminQueue, setAdminQueue] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(initialRouting.isAuthenticated);
  const [currentUser, setCurrentUser] = useState(initialRouting.currentUser);
  const [operationsSummary, setOperationsSummary] = useState(null);

  const refreshOperationsSummary = useCallback(async () => {
    try {
      const data = await adminService.getOperationsSummary();
      setOperationsSummary(data);
    } catch (e) {
      console.warn('operations-summary:', e.response?.status || e.message);
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated || currentPage !== 'admin') return undefined;
    refreshOperationsSummary();
    const iv = window.setInterval(refreshOperationsSummary, 75000);
    const onEvt = () => refreshOperationsSummary();
    window.addEventListener(ADMIN_OPS_REFRESH, onEvt);
    return () => {
      window.clearInterval(iv);
      window.removeEventListener(ADMIN_OPS_REFRESH, onEvt);
    };
  }, [isAuthenticated, currentPage, refreshOperationsSummary]);

  useEffect(() => {
    const syncFromUrl = () => {
      const raw = resolvePageFromPath(window.location.pathname, window.location.search, window.location.hash);
      if (raw.replacePath) {
        window.history.replaceState({}, '', raw.replacePath);
      }
      const page = applyAdminRouteGuards(raw.page);
      setCurrentPage(page);
      if (raw.brandId) setBrandLandingId(raw.brandId);
    };

    window.addEventListener('popstate', syncFromUrl);
    return () => window.removeEventListener('popstate', syncFromUrl);
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_GA_TRACKING_ID) {
      trackPageView(window.location.pathname + window.location.search);
    }
  }, [currentPage]);


  const navigateAdmin = (section, queue = '') => {
    setAdminSection(section);
    setAdminQueue(queue || '');
  };

  const renderAdminSection = () => {
    switch (adminSection) {
      case 'dashboard':
        return (
          <SimpleDashboard
            operationsSummary={operationsSummary}
            onNavigate={navigateAdmin}
          />
        );
      case 'members':
        return <MembersManagement />;
      case 'users':
        return <UserManagement />;
      case 'settings':
        return <SystemSettings />;
      case 'logs':
        return <ActivityLogs />;
      case 'products':
        return <ProductManagement />;
      case 'gp-projects':
        return <GrowthPartnerProjects onNavigate={navigateAdmin} />;
      case 'canal-tienda':
        return <CanalTiendaPanel onNavigate={navigateAdmin} />;
      case 'marketing-hub':
        return <MarketingHub />;
      case 'testimonios':
        return <TestimoniosAdmin />;
      case 'orders':
        return (
          <OrdersManagement
            key={`orders-${adminQueue || 'all'}`}
            initialQueue={adminQueue}
          />
        );
      case 'bienestar-bookings':
        return <BienestarBookingsManagement />;
      case 'packaging':
        return <PackagingManagement />;
      case 'invoices':
        return <InvoicesManagement />;
      case 'cotizaciones':
        return <QuotationsManagement />;
      default:
        return (
          <SimpleDashboard
            operationsSummary={operationsSummary}
            onNavigate={navigateAdmin}
          />
        );
    }
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'admin':
        if (!isAuthenticated) {
          return (
            <ErrorBoundary>
              <AdminLoginPage onLoginSuccess={handleLoginSuccess} />
            </ErrorBoundary>
          );
        }
        return (
          <ErrorBoundary>
            <AdminLayout
              currentUser={currentUser}
              activeSection={adminSection}
              activeQueue={adminQueue}
              operationsSummary={operationsSummary}
              processKey={SECTION_PROCESS_KEYS[adminSection]}
              onNavigate={navigateAdmin}
              onGoHome={goToHome}
              onLogout={handleLogout}
            >
              {renderAdminSection()}
            </AdminLayout>
          </ErrorBoundary>
        );
      case 'quotation-upload':
        return (
          <ErrorBoundary>
            <QuotationPublicUploadPage />
          </ErrorBoundary>
        );
      case 'bienestar-reservar':
        return (
          <ErrorBoundary>
            <BienestarReservarPage />
          </ErrorBoundary>
        );
      case 'bienestar-yoga':
        return (
          <ErrorBoundary>
            <BienestarYogaPage />
          </ErrorBoundary>
        );
      case 'bienestar-entrenamiento':
        return (
          <ErrorBoundary>
            <BienestarEntrenamientoPage />
          </ErrorBoundary>
        );
      case 'bienestar-conecta':
        return (
          <ErrorBoundary>
            <BienestarConectaPage />
          </ErrorBoundary>
        );
      case 'bienestar-reprogramar':
        return (
          <ErrorBoundary>
            <BienestarReprogramarPage />
          </ErrorBoundary>
        );
      case 'conoce-colombia':
        return (
          <ErrorBoundary>
            <ConoceColombiaPage />
          </ErrorBoundary>
        );
      case 'voluntariado':
        return (
          <ErrorBoundary>
            <VoluntariadoPage />
          </ErrorBoundary>
        );
      case 'contacto':
        return (
          <ErrorBoundary>
            <ContactoPage />
          </ErrorBoundary>
        );
      case 'faq-ayuda':
        return (
          <ErrorBoundary>
            <FaqAyudaPage />
          </ErrorBoundary>
        );
      case 'noticias':
        return (
          <ErrorBoundary>
            <NewsPage />
          </ErrorBoundary>
        );
      case 'servicios':
      case 'product-studio':
        return (
          <ErrorBoundary>
            <ProductStudioLanding />
          </ErrorBoundary>
        );
      case 'proyectos':
        return (
          <ErrorBoundary>
            <ProyectosDigitalesPage />
          </ErrorBoundary>
        );
      case 'brand-landing':
        return (
          <ErrorBoundary>
            <BrandLandingPage brandId={brandLandingId} />
          </ErrorBoundary>
        );
      case 'linaje-mock':
        return (
          <ErrorBoundary>
            <LinajeMockLanding />
          </ErrorBoundary>
        );
      case 'tienda':
        return (
          <ErrorBoundary>
            <TiendaPage />
          </ErrorBoundary>
        );
      case 'costal-home':
        return (
          <ErrorBoundary>
            <CostalHomePage />
          </ErrorBoundary>
        );
      case 'costal-comunidad':
        return (
          <ErrorBoundary>
            <CostalComunidadPage />
          </ErrorBoundary>
        );
      case 'growth-partner':
        return (
          <ErrorBoundary>
            <GrowthPartnerPage />
          </ErrorBoundary>
        );
      case 'checkout':
        return (
          <ErrorBoundary>
            <Checkout />
          </ErrorBoundary>
        );
      case 'productos':
        return (
          <ErrorBoundary>
            <ProductosPage />
          </ErrorBoundary>
        );
      case 'producto-detail':
        return (
          <ErrorBoundary>
            <ProductDetailPage key={window.location.pathname} />
          </ErrorBoundary>
        );
      case 'reset-password':
        return (
          <ErrorBoundary>
            <ResetPasswordPage 
              onClose={() => setCurrentPage('home')}
              onSuccess={() => {
                window.history.pushState({}, '', '/admin-login');
                setCurrentPage('admin-login');
              }}
            />
          </ErrorBoundary>
        );
      case 'terms-and-conditions':
        return (
          <ErrorBoundary>
            <TermsAndConditionsPage />
          </ErrorBoundary>
        );
      case 'privacy-policy':
        return (
          <ErrorBoundary>
            <PrivacyPolicyPage />
          </ErrorBoundary>
        );
      case 'refund-policy':
        return (
          <ErrorBoundary>
            <RefundPolicyPage />
          </ErrorBoundary>
        );
      case 'comunidad':
      case 'comunidad-auth':
        return (
          <ErrorBoundary>
            <ComunidadPage />
          </ErrorBoundary>
        );
      case 'comunidad-restablecer':
        return (
          <ErrorBoundary>
            <MemberResetPasswordPage />
          </ErrorBoundary>
        );
      case 'admin-login':
        return (
          <ErrorBoundary>
            <AdminLoginPage onLoginSuccess={handleLoginSuccess} />
          </ErrorBoundary>
        );
      case 'perfil':
        return (
          <ErrorBoundary>
            <MemberPerfilPage />
          </ErrorBoundary>
        );
      case 'user-login':
        return (
          <ErrorBoundary>
            <UserLogin />
          </ErrorBoundary>
        );
      case 'user-register':
        return (
          <ErrorBoundary>
            <UserRegistration />
          </ErrorBoundary>
        );
      case 'home':
      default:
        return (
          <ErrorBoundary>
            <HomePage onShowLogin={goToComunidad} />
          </ErrorBoundary>
        );
    }
  };

  const goToAdmin = () => {
    if (isAuthenticated) {
      window.history.pushState({}, '', '/admin');
      setCurrentPage('admin');
    } else {
      window.history.pushState({}, '', '/admin-login');
      setCurrentPage('admin-login');
    }
  };

  const goToComunidad = () => {
    window.history.pushState({}, '', '/comunidad/ingresar');
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const goToHome = () => {
    window.history.pushState({}, '', '/');
    setCurrentPage('home');
  };
  
  const goToEcommerce = () => {
    window.history.pushState({}, '', '/tienda');
    setCurrentPage('tienda');
  };

  const handleLoginSuccess = (userData) => {
    setIsAuthenticated(true);
    setCurrentUser(userData);
    window.history.pushState({}, '', '/admin');
    setCurrentPage('admin');
  };

  const handleLogout = async () => {
    localStorage.removeItem('javiland_token');
    localStorage.removeItem('javiland_user');

    setIsAuthenticated(false);
    setCurrentUser(null);
    setCurrentPage('home');

    window.location.href = '/';
  };

  const seo = getSeoForPage(currentPage);
  const isCostalChrome =
    currentPage === 'tienda' ||
    currentPage === 'producto-detail' ||
    currentPage === 'costal-home' ||
    currentPage === 'costal-comunidad' ||
    currentPage === 'comunidad-auth' ||
    currentPage === 'comunidad-restablecer';

  return (
    <div className="app">
      <SEOHead
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        robots={seo.robots}
      />
      {/* Header general - Solo visible en home, e-commerce, términos y privacidad, NO en admin ni checkout */}
      {currentPage !== 'admin' && currentPage !== 'admin-login' && currentPage !== 'reset-password' && currentPage !== 'user-login' && currentPage !== 'user-register' && currentPage !== 'checkout' && currentPage !== 'linaje-mock' && (
        <Header
          onCommunityClick={goToComunidad}
          onEcommerceClick={goToEcommerce}
          brandVariant={isCostalChrome ? 'costal' : 'javiland'}
        />
      )}
      
      {/* Contenido de la página */}
      <main
        className={`main-content${
          currentPage === 'admin-login' ? ' main-content--no-header' : ''
        }${currentPage === 'admin' && isAuthenticated ? ' main-content--admin' : ''}${
          currentPage === 'checkout' || currentPage === 'linaje-mock' ? ' main-content--checkout' : ''
        }${
          currentPage === 'costal-home' || currentPage === 'costal-comunidad' ? ' main-content--costal' : ''
        }`}
      >
        {renderPage()}
      </main>

      {currentPage !== 'admin' && currentPage !== 'admin-login' && currentPage !== 'reset-password' && currentPage !== 'user-login' && currentPage !== 'user-register' && currentPage !== 'checkout' && currentPage !== 'quotation-upload' && currentPage !== 'linaje-mock' && (
        <Footer onAdminNavigate={goToAdmin} brandVariant={isCostalChrome ? 'costal' : 'javiland'} />
      )}

      {/* Carrito solo en ecosistema Costal (tienda / ficha / checkout). Hub Javiland = puente sin compra. */}
      {(currentPage === 'tienda' ||
        currentPage === 'producto-detail' ||
        currentPage === 'checkout' ||
        currentPage === 'costal-home' ||
        currentPage === 'costal-comunidad') && (
        <ShoppingCart />
      )}

      <GeoShippingNotice />

      {/* Preloader para componentes críticos */}
      <Preloader />
    </div>
  );
};

export default AppRouter;
